import { createTheme } from '@mui/material';

export const theme = createTheme({
  typography: {
    fontFamily: ['Inter', 'Helvetica', 'Arial', 'serif'].join(', '),
  },
});
